import { MetaData } from './metadata';
import { Retailer } from './retailer';

export class RetailerDto {
  constructor(public metadata: MetaData, public results: Retailer[]) {}
}
